import CancelForm from 'components/ModalCancelOrder/Sections/CancelForm/styled';

export default CancelForm;
